var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 100.0 100.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l100.0 0l0 100.0l-100.0 0l0 -100.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    fillOpacity: 0,
    d: "m0 0l100.0 0l0 100.0l-100.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m11.204724 11.146785l77.60629 0c1.5871277 0 3.1092453 0.6304817 4.2315063 1.7527466c1.1222687 1.1222649 1.7527466 2.6443834 1.7527466 4.2315054l0 5.984251c0 4.1389465E-4 -3.2806396E-4 7.4768066E-4 -7.4005127E-4 7.4768066E-4l-89.57406 -7.4768066E-4l0 0c-4.119873E-4 0 -7.4625015E-4 -3.33786E-4 -7.4625015E-4 -7.457733E-4l7.4625015E-4 -5.9835052l0 0c0 -3.3050108 2.6792412 -5.984252 5.984252 -5.984252z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m5.2204723 71.31996l89.5748 0c1.9836426E-4 0 3.8909912E-4 7.6293945E-5 5.340576E-4 2.1362305E-4c1.373291E-4 1.449585E-4 2.1362305E-4 3.3569336E-4 2.1362305E-4 5.340576E-4l-7.4768066E-4 8.770905l0 0c0 4.844452 -3.9272003 8.771652 -8.771652 8.771652l-72.031494 0c-4.84445 0 -8.771653 -3.9272003 -8.771653 -8.771652l0 -8.771652l0 0c0 -4.119873E-4 3.3426285E-4 -7.4768066E-4 7.46727E-4 -7.4768066E-4z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m5.2204723 21.05256l26.64567 0l0 35.74803l-26.64567 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m68.14173 21.052494l26.645668 0l0 35.244095l-26.645668 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m47.81158 38.257423l0 0l0.5732994 0.5732994l0 3.0285072l-0.5732994 0.5732956l0 0l-0.5732956 -0.5732956l0 -3.0285072z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m52.15286 42.64232l0 0l-0.5732994 0.5732994l-3.0285072 0l-0.5732956 -0.5732994l0 0l0.5732956 -0.5732956l3.0285072 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m52.310722 33.63573l0 0l0.5732956 0.5732994l0 3.0285072l-0.5732956 0.5732956l0 0l-0.5732994 -0.5732956l0 -3.0285072z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m52.161167 38.020626l0 0l-0.5732994 0.5732994l-3.0285072 0l-0.5732956 -0.5732994l0 0l0.5732956 -0.5732956l3.0285072 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m52.161167 33.398933l0 0l-0.5732994 0.5732994l-3.0285072 0l-0.5732956 -0.5732994l0 0l0.5732956 -0.5732956l3.0285072 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m55.078545 38.257423l0 0l0.5732994 0.5732994l0 3.0285072l-0.5732994 0.5732956l0 0l-0.5732956 -0.5732956l0 -3.0285072z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m59.569378 38.257423l0 0l0.5732956 0.5732994l0 3.0285072l-0.5732956 0.5732956l0 0l-0.5732994 -0.5732956l0 -3.0285072z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m59.41982 42.64232l0 0l-0.5732956 0.5732994l-3.0285072 0l-0.5732994 -0.5732994l0 0l0.5732994 -0.5732956l3.0285072 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m55.086853 33.63573l0 0l0.5732994 0.5732994l0 3.0285072l-0.5732994 0.5732956l0 0l-0.5732956 -0.5732956l0 -3.0285072z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m59.428127 38.020626l0 0l-0.5732956 0.5732994l-3.0285072 0l-0.5732994 -0.5732994l0 0l0.5732994 -0.5732956l3.0285072 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m59.428127 33.398933l0 0l-0.5732956 0.5732994l-3.0285072 0l-0.5732994 -0.5732994l0 0l0.5732994 -0.5732956l3.0285072 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m40.54462 38.257423l0 0l0.5732956 0.5732994l0 3.0285072l-0.5732956 0.5732956l0 0l-0.5732994 -0.5732956l0 -3.0285072z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m45.03545 38.257423l0 0l0.5732994 0.5732994l0 3.0285072l-0.5732994 0.5732956l0 0l-0.5732956 -0.5732956l0 -3.0285072z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m44.885895 42.64232l0 0l-0.5732994 0.5732994l-3.0285072 0l-0.5732956 -0.5732994l0 0l0.5732956 -0.5732956l3.0285072 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m40.55293 33.63573l0 0l0.5732956 0.5732994l0 3.0285072l-0.5732956 0.5732956l0 0l-0.5732994 -0.5732956l0 -3.0285072z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m45.04376 33.63573l0 0l0.5732994 0.5732994l0 3.0285072l-0.5732994 0.5732956l0 0l-0.5732956 -0.5732956l0 -3.0285072z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m44.894203 33.398933l0 0l-0.5732994 0.5732994l-3.0285072 0l-0.5732956 -0.5732994l0 0l0.5732956 -0.5732956l3.0285072 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m1.0393701 6.3648295l97.921265 0c0.27565765 0 0.5400238 0.1095047 0.7349396 0.3044243c0.1949234 0.19491959 0.3044281 0.45928764 0.3044281 0.7349458l0 1.0393696c0 4.606247E-4 -3.7384033E-4 8.3351135E-4 -8.31604E-4 8.3351135E-4l-99.99917 -8.3351135E-4l1.4354554E-19 0c-4.602373E-4 0 -8.3333335E-4 -3.7288666E-4 -8.3333335E-4 -8.325577E-4l8.3333335E-4 -1.038537l0 0c0 -0.5740285 0.46534184 -1.0393701 1.0393701 -1.0393701z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m0 93.51181l100.0 0c2.2125244E-4 0 4.348755E-4 9.1552734E-5 5.874634E-4 2.4414062E-4c1.6021729E-4 1.6021729E-4 2.4414062E-4 3.6621094E-4 2.4414062E-4 5.874634E-4l-8.31604E-4 1.0385361l0 0c0 0.574028 -0.46533966 1.0393753 -1.0393677 1.0393753l-97.921265 0c-0.57402825 0 -1.0393701 -0.4653473 -1.0393701 -1.0393753l0 -1.0393677l0 0c0 -4.5776367E-4 3.7309603E-4 -8.31604E-4 8.3333335E-4 -8.31604E-4z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m0 8.0l1.480315 0l0 86.11024l-1.480315 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m98.519684 8.0l1.4803162 0l0 86.11024l-1.4803162 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m2.2913387 11.501312l0 0c0 -0.8088579 0.6557088 -1.4645672 1.464567 -1.4645672l0 0c0.38842726 0 0.7609453 0.1543026 1.035605 0.42896175c0.27465963 0.2746601 0.42896175 0.64717865 0.42896175 1.0356054l0 0c0 0.8088579 -0.6557088 1.4645672 -1.4645667 1.4645672l0 0c-0.80885816 0 -1.464567 -0.65570927 -1.464567 -1.4645672z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m95.185036 11.501312l0 0c0 -0.8088579 0.65571594 -1.4645672 1.4645691 -1.4645672l0 0c0.38842773 0 0.7609482 0.1543026 1.0356064 0.42896175c0.2746582 0.2746601 0.4289627 0.64717865 0.4289627 1.0356054l0 0c0 0.8088579 -0.6557083 1.4645672 -1.4645691 1.4645672l0 0c-0.80885315 0 -1.4645691 -0.65570927 -1.4645691 -1.4645672z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m2.2913387 90.31759l0 0c0 -0.8088608 0.6557088 -1.4645691 1.464567 -1.4645691l0 0c0.38842726 0 0.7609453 0.1543045 1.035605 0.4289627c0.27465963 0.2746582 0.42896175 0.64717865 0.42896175 1.0356064l0 0c0 0.80885315 -0.6557088 1.4645615 -1.4645667 1.4645615l0 0c-0.80885816 0 -1.464567 -0.6557083 -1.464567 -1.4645615z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m95.185036 90.31759l0 0c0 -0.8088608 0.65571594 -1.4645691 1.4645691 -1.4645691l0 0c0.38842773 0 0.7609482 0.1543045 1.0356064 0.4289627c0.2746582 0.2746582 0.4289627 0.64717865 0.4289627 1.0356064l0 0c0 0.80885315 -0.6557083 1.4645615 -1.4645691 1.4645615l0 0c-0.80885315 0 -1.4645691 -0.6557083 -1.4645691 -1.4645615z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m31.181103 44.317585l37.606297 0l0 12.472443l-37.606297 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m42.818897 59.603676l14.3622055 0l0 1.1338577l-14.3622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m42.818897 63.55118l14.3622055 0l0 1.1338539l-14.3622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m42.818897 67.49869l24.377956 0l0 1.1338577l-24.377956 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m47.02362 56.330708l1.5118141 0l0 15.87402l-1.5118141 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m51.404198 56.21522l1.4803162 0l0 15.87402l-1.4803162 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m55.839893 56.312336l7.874016 0l0 18.110233l-7.874016 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m5.2204723 56.312336l38.92913 0l0 17.543308l-38.92913 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m66.656166 67.91338l11.685043 0l0 4.18898l-11.685043 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m63.29659 62.002625l0 0c0 -4.166054 3.3772545 -7.5433083 7.5433083 -7.5433083l0 0c2.0006104 0 3.9192734 0.79473877 5.3339233 2.209385c1.4146423 1.4146461 2.209381 3.333313 2.209381 5.3339233l0 0c0 4.166054 -3.3772507 7.5433044 -7.5433044 7.5433044l0 0c-4.166054 0 -7.5433083 -3.3772507 -7.5433083 -7.5433044zm2.0389519 0l0 0c0 3.0399704 2.464386 5.5043488 5.5043564 5.5043488c3.0399704 0 5.5043488 -2.4643784 5.5043488 -5.5043488l0 0c0 -3.0399704 -2.4643784 -5.5043526 -5.5043488 -5.5043526l0 0c-3.0399704 0 -5.5043564 2.4643822 -5.5043564 5.5043526z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m63.335957 67.91207l0 -4.503933l2.9291344 4.503933z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m63.335957 56.33098l0 4.755905l2.9291344 -4.755905z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m78.333336 68.632545l0 -6.015747l-4.18898 6.015747z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m78.333336 56.215504l0 4.787403l-2.9291382 -4.787403z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m76.71654 55.824146l18.078735 0l0 15.87402l-18.078735 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m71.879265 61.639107l2.2047272 0l0 -0.3622055l0.7244034 0.724411l-0.7244034 0.724411l0 -0.3622055l-2.2047272 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m71.2021 62.972443l0 2.2047195l0.3622055 0l-0.724411 0.724411l-0.724411 -0.724411l0.3622055 0l0 -2.2047195z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m69.80052 62.36483l-2.2047195 0l0 0.3622055l-0.724411 -0.724411l0.724411 -0.724411l0 0.3622055l2.2047195 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m70.47244 60.96194l0 -2.2047234l-0.3622055 0l0.724411 -0.7244072l0.7244034 0.7244072l-0.36219788 0l0 2.2047234z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresion);
export default __webpack_public_path__ + "static/media/presion.b504e882a160b154eae1f5d746cc3f3a.svg";
export { ForwardRef as ReactComponent };